/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnumTypesDto as DigiworkMaitreDPosDtoEnumTypesEnumTypesDto } from '../../models/Digiwork/MaitreD/Pos/DTO/EnumTypes/enum-types-dto';

export interface GetTableShapeTypes$Params {
}

export function getTableShapeTypes(http: HttpClient, rootUrl: string, params?: GetTableShapeTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoEnumTypesEnumTypesDto>> {
  const rb = new RequestBuilder(rootUrl, getTableShapeTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoEnumTypesEnumTypesDto>;
    })
  );
}

getTableShapeTypes.PATH = '/api/groups/layouts/tables/shapes';
